import { render, staticRenderFns } from "./CopyAccount.vue?vue&type=template&id=d964b234&scoped=true&"
import script from "./CopyAccount.vue?vue&type=script&lang=js&"
export * from "./CopyAccount.vue?vue&type=script&lang=js&"
import style0 from "./CopyAccount.vue?vue&type=style&index=0&id=d964b234&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d964b234",
  null
  
)

export default component.exports